/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetDistinct } from '../../factoriesAny.js';
export var setDistinctDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  IndexDependencies: IndexDependencies,
  compareNaturalDependencies: compareNaturalDependencies,
  sizeDependencies: sizeDependencies,
  subsetDependencies: subsetDependencies,
  typedDependencies: typedDependencies,
  createSetDistinct: createSetDistinct
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSetDistinct.generated.js
// module id = 1646
// module chunks = 0